<template>
  <div class="content" v-if="$auth.ready()" style="overflow: auto; margin-top: 2rem">
    <div class="content">
      <h1 class="has-text-centered has-text-white">
        <span style="color: yellow;">FREE TRIAL! TEAM CHANGE RISK ASSESSMENT</span>
      </h1>
    </div>
    <div class="columns is-centered is-gapless">
      <div class="column is-half-tablet is-one-third-desktop">
        <div class="box">
          <form id="fromData">
            <div class="field">
              <h2 class="has-text-primary has-text-centered">Welcome to ChangeVU!</h2>
              <hr></hr>
              <p class="intro-text">
                Please add and confirm your password to complete your account set up.
              </p>

              <div class="field">
                <label class="label">Your name</label>
                <p class="control has-icon">
                  <input v-model="user.firstName" class="input" type="text" placeholder="Your first name">
                  <span class="icon is-small">
                    <i class="fa fa-user"></i>
                  </span>
                </p>
                <p class="control has-icon">
                  <input v-model="user.lastName" class="input" type="text" placeholder="Your last name">
                  <span class="icon is-small">
                    <i class="fa fa-user"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label">Password</label>
                <p class="control has-icon">
                  <input v-model="user.password" class="input" type="password" placeholder="Password">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                </p>
                <p class="help">Password should be minimum 8 characters which contain at least one numeric digit and a special character.</p>
              </div>
              <div class="field">
                <label class="label">Confirm password</label>
                <p class="control has-icon">
                  <input v-model="user.confirmPassword" class="input" type="password" placeholder="Confirm password">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <div class="control">
                  <label class="checkbox help has-text-grey">
                    <input type="checkbox" v-model="user.agree">
                    I agree to the&nbsp;<a href="#/terms" target="_blank">ChangeVU Terms of Use</a>
                  </label>
                </div>
              </div>
            </div>
            <div class="field">
              <p class="control progress-btn">
                <span v-if="!isInvited">
                  <a href="#/login">Already have an account?</a>
                </span>
                <button @click.prevent="onBoard()" class="button is-primary btnRight">Done&nbsp;<span class="is-hidden-mobile">&amp; Do My Assessment</span>&nbsp;<i class="fa fa-chevron-right"></i></button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import router from '../../router'

export default {
  components: {
  },
  data () {
    return {
      step: 1,
      isInvited: false,
      user: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        agree: false,
        type: '',
        role: ''
      },
      initiative: {
        id: '',
        initiativeName: '',
        deadline: '',
        teamName: ''
      }
    }
  },
  mounted () {
    let path = this.$route.path
    path = path.split('/')
    if (path[2]) {
      this.user.id = path[2]
      axios.get(globalConstants.apiURL + '/api/v1/users/' + this.user.id)
        .then(response => {
          this.user.email = response.data.email
        })
        .catch(error => {
          console.log('error on saving users' + error)
          this.$noty.error(error.response.data.message)
        })
    }
  },
  methods: {
    login () {
      this.$auth.login({
        url: globalConstants.apiURL + '/auth/local',
        body: this.user,
        success: function (res) {
          axios.get(globalConstants.apiURL + '/auth/local')
          .then(response => {
            this.$cookie.set('token', res.data.token)
            this.$cookie.set('role', response.data.role)
            this.$store.commit('setUserImageSrc', globalConstants.apiURL + '/uploads/' + 'extra-large.jpg')
            this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/uploads/' + 'changeVULogo.png')
            this.$store.commit('setCurrentUserName', response.data.firstName)
            window.localStorage.setItem('user', JSON.stringify(response.data))

            // following code needs to optimized
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.user = user
            let currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'))
            this.currentInitiative = currentInitiative
            let diagonactic
            if (currentInitiative) {
              for (var i = 0; i < user.diagonactics.length; i++) {
                if (user.diagonactics[i].initiative === currentInitiative.id) {
                  diagonactic = user.diagonactics[i]
                  break
                }
              }
            }
            if (diagonactic) {
              this.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '')
              this.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '')
              this.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '')
              this.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '')
              this.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '')
              this.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '')
              this.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '')
              this.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '')
              this.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '')
              this.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '')
              this.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '')
              this.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '')
              this.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '')
              this.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '')
              this.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '')
              this.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '')
            }
            router.push({ path: '/home' })
          })
          .catch(error => {
            console.log(error)
          })
        },
        data: this.user
      })
    },
    validatePassword (password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/
      return re.test(password)
    },
    onBoard () {
      if (this.user.firstName === undefined || this.user.firstName === null || this.user.firstName.trim() === '') {
        this.$noty.error('Please enter your first name.')
      } else if (this.user.lastName === undefined || this.user.lastName === null || this.user.lastName.trim() === '') {
        this.$noty.error('Please enter your last name.')
      } else if (this.user.password === undefined || this.user.password === null || this.user.password.trim() === '') {
        this.$noty.error('Please enter a password.')
      } else if (!this.validatePassword(this.user.password)) {
        this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.')
      } else if (this.user.confirmPassword === undefined || this.user.confirmPassword === null || this.user.confirmPassword.trim() === '') {
        this.$noty.error('Please confirm the password.')
      } else if (this.user.password !== this.user.confirmPassword) {
        this.$noty.error('Password and confirm password does not match.')
      } else if (this.user.agree === false) {
        this.$noty.error('Please accept our Terms of Use')
      } else {
        this.user.role = 'TM'
        axios.post(globalConstants.apiURL + '/api/v1/users', {user: this.user})
          .then(response => {
            this.login()
          })
          .catch(error => {
            console.log('error on saving users' + error)
            this.$noty.error(error.response.data.message)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .intro-text {
    margin-bottom: 1rem !important;
  }
  @media screen and (max-width: 767px) {
    margin-top: 2rem;
  }
  .mb-2 {
    margin-bottom: 2rem !important;
  }
}
.control.has-icons-right .icon {
  pointer-events: auto !important;
  cursor: pointer;
}

.checkbox {
  display: flex !important;
  align-items: center;
  input[type="checkbox"] {
    margin-right: 5px;
  }
}

.progress-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btnRight {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// OnBoardMember.vue?1f30680e